import { authenticatedClient } from '../lib/client';
import { PHONE_NUMBER_ENDPOINTS } from './phone_numbers.utils';
import type { ApiResponse } from '../lib/types';
import type { 
    PhoneNumberDetails, 
    CreatePhoneNumberPayload,
    UpdatePhoneNumberPayload 
} from './phone_numbers.types';

export const getPhoneNumbers = async (): Promise<ApiResponse<PhoneNumberDetails[]>> => {
    try {
        const response = await authenticatedClient.get(PHONE_NUMBER_ENDPOINTS.GET_ALL);
        // console.log("Phone numbers:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch phone numbers' };
    }
};

export const getPhoneNumberById = async (phoneNumberId: string): Promise<ApiResponse<PhoneNumberDetails>> => {
    try {
        const response = await authenticatedClient.get(PHONE_NUMBER_ENDPOINTS.GET_BY_ID(phoneNumberId));
        // console.log("Phone number:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch phone number' };
    }
};

export const createPhoneNumber = async (payload: CreatePhoneNumberPayload): Promise<ApiResponse<PhoneNumberDetails>> => {
    try {
        // Validate payload based on provider type
        if (payload.provider === 'byo-phone-number') {
            // For BYO provider, ensure numberE164CheckEnabled is true
            payload = {
                ...payload,
                numberE164CheckEnabled: true
            };
        }

        const response = await authenticatedClient.post(PHONE_NUMBER_ENDPOINTS.CREATE, payload);
        // console.log("Created phone number:", response.data);
        return { data: response.data };
    } catch (error: unknown) {
        if (error instanceof Error) {
            return { error: (error as any).response?.data?.message || error.message };
        }
        return { error: 'Failed to create phone number' };
    }
};

export const updatePhoneNumber = async (
    phoneNumberId: string,
    payload: UpdatePhoneNumberPayload
): Promise<ApiResponse<PhoneNumberDetails>> => {
    try {
        // console.log('Updating phone number with payload:', JSON.stringify(payload, null, 2));
        const response = await authenticatedClient.patch(PHONE_NUMBER_ENDPOINTS.UPDATE(phoneNumberId), payload);
        // console.log("Updated phone number response:", response.data);
        return { data: response.data };
    } catch (error: any) {
        // console.error('Update phone number error:', error);
        // console.error('Error response:', error.response?.data);
        return { 
            error: error.response?.data?.detail || 
                  error.response?.data?.message || 
                  error.message || 
                  'Failed to update phone number' 
        };
    }
};

export const deletePhoneNumber = async (phoneNumberId: string): Promise<ApiResponse<PhoneNumberDetails>> => {
    try {
        const response = await authenticatedClient.delete(PHONE_NUMBER_ENDPOINTS.DELETE(phoneNumberId));
        // console.log("Deleted phone number:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to delete phone number' };
    }
};
